export const RSA_ID_HEADER = 'RSA-ID';

export const useApiRsa = (() => {
  const apiRsaId: Record<string, string> = {};

  const setRsaId = ({ key, rsaId }: { key: string; rsaId: string }) => {
    apiRsaId[key] = rsaId;
  };

  const getRsaId = ({ key }: { key: string }) => {
    return apiRsaId[key];
  };

  // POST, PUT, PATCH만 지원 (openapi 함수용 - { request: ... } 형태)
  const handleApiRsaId = <Fn extends (p: any) => any>({
    fn,
    params,
    rsaId,
    key,
    requestName = 'request',
  }: {
    fn: Fn;
    params: Parameters<Fn>[0];
    rsaId?: string;
    key?: string;
    requestName?: string;
  }): ReturnType<Fn> => {
    if (rsaId) {
      const fnKey = key ?? fn.name; // unique
      setRsaId({
        key: fnKey,
        rsaId,
      });

      params[requestName] = {
        ...params[requestName],
        [RSA_ID_HEADER]: fnKey,
      };
    }

    return fn(params);
  };

  // api-client 함수용
  const handleApiClientRsaId = <Fn extends (...args: any[]) => any>({
    fn,
    params,
    args,
    rsaDataIndex = 0,
    rsaId,
    key,
  }: {
    fn: Fn;
    params?: Parameters<Fn>[0];
    args?: Parameters<Fn>;
    rsaDataIndex?: number;
    rsaId?: string;
    key?: string;
  }): ReturnType<Fn> => {
    const finalArgs = (args ?? [params]) as Parameters<Fn>;

    if (rsaId) {
      const fnKey = key ?? fn.name;
      setRsaId({ key: fnKey, rsaId });
      finalArgs[rsaDataIndex] = {
        ...finalArgs[rsaDataIndex],
        [RSA_ID_HEADER]: fnKey,
      };
    }

    return fn(...finalArgs);
  };

  return () => ({
    setRsaId,
    getRsaId,
    handleApiRsaId,
    handleApiClientRsaId,
  });
})();
